import axios from 'axios';
import {
  useEffect, useMemo, useState,
} from 'react';
import Select from 'react-select';
import { axiosMicro } from '~/services';
import { CustomSelectInput } from '../CustomSelectInput';

function fetchData(config, params = {}) {
  return new Promise((resolve, reject) => {
    if (/^https?:\/\//.test(config.path)) {
      return axios.get(config.path, {
        params,
      }).then((json) => resolve(json.data))
        .catch((err) => reject(err));
    }

    return axiosMicro.get(config.path, {
      params,
    }).then((json) => resolve(json.data))
      .catch((err) => reject(err));
  });
}

function parseData(json, object, config) {
  try {
    if (object.length > 1) {
      return parseData(json[object[0]], object.slice(1), config);
    }

    if (!object[0].length) {
      return json.map((item, index) => ({
        value: item[config.value].toString(),
        label: item[config.title],
        key: index,
      }));
    }

    return json[object[0]].map((item, index) => ({
      value: item[config.value].toString(),
      label: item[config.title],
      key: index,
    }));
  } catch {
    return [];
  }
}

export const SelectApi = ({
  name,
  config,
  value,
  onChange,
}) => {
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null);
  const option = useMemo(() => {
    if (!config || !config.path || !config.value || !config.title) {
      return null;
    }

    return config;
  }, [config]);

  useEffect(() => {
    if (option) {
      fetchData(option).then((async (res) => {
        const ls = await parseData(res, option.object.split('.'), option);
        setList(ls);
      }));
    }
  }, [option]);

  useEffect(() => {
    if (list.length && value && value !== selected?.value) {
      setSelected(list.find((item) => item.value === value));
    }
  }, [list, value]);

  const handleChange = (val) => {
    setSelected(val);
    onChange(val.value);
  };

  return (
    <Select
      components={{ Input: CustomSelectInput }}
      className="react-select w-100"
      classNamePrefix="react-select"
      isClearable
      name={name}
      value={selected}
      onChange={handleChange}
      options={list}
    />
  );
};
